import { Link, useParams, useSearchParams } from "react-router-dom";
import apiAgent from "../api/apiAgent";
import { useState } from "react";
import { tMsg } from "../components/ToastNotifications";
import { Button } from "../components/Button";
import { Loader } from "../components/Loader";

interface IResetPasswordData {
  new_pw: string;
  reset_id: string;
}

const ResetPassword = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const reset_id = searchParams.get("r") || "";
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [formData, setFormData] = useState<IResetPasswordData>({
    new_pw: "",
    reset_id,
  });
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const register = async () => {
    try {
      const response = await apiAgent.Auth.resetPassword(formData);
      if (response.status === 200) {
        tMsg.success(`Your password has been reset.`);
        setSubmitted(true);
      }
    } catch (err: any) {
      console.log(err);
      tMsg.error(`Error resetting password: ${err?.response?.data}`);
    } finally {
      setFormData({
        new_pw: "",
        reset_id,
      });
      setSubmitting(false);
      setConfirmPassword("");
    }
  };

  const handleSubmit = () => {
    if (formData.new_pw?.length < 1) {
      tMsg.error("Please give a valid password");
      return;
    }
    if (confirmPassword !== formData.new_pw) {
      tMsg.error("Passwords do not match");
      return;
    }
    register();
  };

  const updateFormData = (keyName: string, value: string) => {
    const newFormData = {
      ...formData,
      [keyName]: value,
    };
    setFormData(newFormData);
  };

  const SubmittedElement = () => (
    <>
      <h1 className="font-bold text-lg">Your password has been reset</h1>
      <div className="text-sm my-4">Please login again</div>
      <div className="text-white/70 hover:text-white transition">
        <Link to="/login">Return to login page</Link>
      </div>
    </>
  );

  return (
    <div className="w-full h-full grid content-center bg-gray-700">
      <div className="space-y-4 flex flex-col justify-center">
        <div className="font-medium place-self-center w-64 space-y-4 text-center">
          {!submitted ? (
            <>
              <h1 className="font-bold text-lg">Reset your password</h1>
              <div className="text-sm">Enter and confirm your new password</div>
              <form className="grid place-items-center">
                <div className="my-4 space-y-2">
                  <div>Password</div>
                  <input
                    className="text-black p-1"
                    autoComplete="off"
                    type={"password"}
                    value={formData.new_pw}
                    onChange={(e) => {
                      e.preventDefault();
                      updateFormData("new_pw", e.target.value);
                    }}
                    required
                  />
                  <div>Confirm Password</div>
                  <input
                    className="text-black p-1"
                    autoComplete="off"
                    type={"password"}
                    value={confirmPassword}
                    onChange={(e) => {
                      e.preventDefault();
                      setConfirmPassword(e.target.value);
                    }}
                    required
                  />
                </div>
                {submitting ? (
                  <Loader />
                ) : (
                  <Button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    Submit
                  </Button>
                )}
              </form>
            </>
          ) : (
            <SubmittedElement />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
